import { render } from "./HtmlTextConfig.vue?vue&type=template&id=3d4e6052&ts=true"
import script from "./HtmlTextConfig.vue?vue&type=script&lang=ts"
export * from "./HtmlTextConfig.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__